export enum actionTypes {
  //fetch faq
  FETCH_FAQ_REQUEST = "FETCH_FAQ_REQUEST",
  FETCH_FAQ_SUCCESS = "FETCH_FAQ_SUCCESS",
  FETCH_FAQ_FAIL = "FETCH_FAQ_FAIL",
  //Create faq
  CREATE_FAQ_REQUEST = "CREATE_FAQ_REQUEST",
  CREATE_FAQ_SUCCESS = "CREATE_FAQ_SUCCESS",
  CREATE_FAQ_FAIL = "CREATE_FAQ_FAIL",
  //Update faq
  UPDATE_FAQ_REQUEST = "UPDATE_FAQ_REQUEST",
  UPDATE_FAQ_SUCCESS = "UPDATE_FAQ_SUCCESS",
  UPDATE_FAQ_FAIL = "UPDATE_FAQ_FAIL",
  //Update faq
  DELETE_FAQ_REQUEST = "DELETE_FAQ_REQUEST",
  DELETE_FAQ_SUCCESS = "DELETE_FAQ_SUCCESS",
  DELETE_FAQ_FAIL = "DELETE_FAQ_FAIL",
  RESET_FAQ = "RESET_FAQ",
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}
export interface FaqProps {
  id: string
  question: string;
  answer: string;
}
export interface FaqInput {
  question: string;
  answer: string;
}
export interface FaqUpdateInput {
  question: string;
  answer: string;
  id:string
}
export interface FaqInputError {
  question?: string;
  answer?: string;
}

//fetch faq
export interface FetchFaqRequestAction {
  type: actionTypes.FETCH_FAQ_REQUEST;
}

export interface FetchFaqSuccessAction {
  type: actionTypes.FETCH_FAQ_SUCCESS;
  payload: FaqProps[];
}

export interface FetchFaqFailureAction {
  type: actionTypes.FETCH_FAQ_FAIL;
  payload: string;
}

//create faq
export interface CreateFaqRequestAction {
  type: actionTypes.CREATE_FAQ_REQUEST;
}

export interface CreateFaqSuccessAction {
  type: actionTypes.CREATE_FAQ_SUCCESS;
  payload: FaqProps;
}

export interface CreateFaqFailureAction {
  type: actionTypes.CREATE_FAQ_FAIL;
  payload: string;
}

//Update faq
export interface UpdateFaqRequestAction {
  type: actionTypes.UPDATE_FAQ_REQUEST;
}
export interface UpdateFaqSuccessAction {
  type: actionTypes.UPDATE_FAQ_SUCCESS;
  payload: FaqProps;
}
export interface UpdateFaqFailAction {
  type: actionTypes.UPDATE_FAQ_FAIL;
  payload: string;
}

//Delete faq
export interface DeleteFaqRequestAction {
  type: actionTypes.DELETE_FAQ_REQUEST;
}
export interface DeleteFaqSuccessAction {
  type: actionTypes.DELETE_FAQ_SUCCESS;
  payload: string;
}
export interface DeleteFaqFailAction {
  type: actionTypes.DELETE_FAQ_FAIL;
  payload: string;
}

export interface ResetFaq {
  type: actionTypes.RESET_FAQ;
}
export type FaqActions =
  | FetchFaqRequestAction
  | FetchFaqSuccessAction
  | FetchFaqFailureAction
  | CreateFaqRequestAction
  | CreateFaqSuccessAction
  | CreateFaqFailureAction
  | UpdateFaqRequestAction
  | UpdateFaqSuccessAction
  | UpdateFaqFailAction
  | DeleteFaqRequestAction
  | DeleteFaqSuccessAction
  | DeleteFaqFailAction
  | ResetFaq;
